import {ResponseIndexRequest} from '../../../networking/requests/Response';

interface IndexKeyParams {
    universityId: number;
    page?: number;
}

interface DetailKeyParams {
    universityId: number;
    responseId: number;
}

interface WithoutPaginationKeyParams extends ResponseIndexRequest{
    universityId: number;
}

export const ResponseQueryKey = {
    base: ['responses'],
    index: (params: IndexKeyParams) => ['responses', params],
    detail: (params: DetailKeyParams) => ['responses', 'detail', params],
    withoutPagination: (params: WithoutPaginationKeyParams) =>  ['responses', 'without-pagination', params], // TODO: Remove and replace with index
};
